/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

import { useDispatch } from "react-redux"; // Import the useDispatch hook from Redux for dispatching actions
import { useTranslation } from "react-i18next"; // Import the i18next hook for translation
import { useEffect, useState } from "react";
import { clearSearchFilters } from "../../../../../reduxToolkit/Search/SearchSlice"; // Import action to clear search filters
import { VIEW_TYPE } from "../../../../../enums/ViewType"; // Import enum for view types

// Main component for managing the Cafeterias tab in the application
const CafeteriasApp = () => {
    // Hook to enable translation functionality in the component
    const { t } = useTranslation();
    // State variables to manage UI and data
    const [view, setView] = useState(VIEW_TYPE.LIST.name); // Current view (list or grid)
    const [selectedList, setSelectedList] = useState([]); // Contracts selected for deletion
    const [isAllChecked, setIsAllChecked] = useState(false); // Flag to indicate if all contracts are selected
    const [finalArray, setFinalArray] = useState([]); // Array to store filtered contracts
    const [contractorId, setContractorId] = useState(sessionStorage.getItem('contractorId')); // Contractor ID from sessionStorage
    const [supplierId, setSupplierId] = useState(sessionStorage.getItem('providerId')); // Supplier ID from sessionStorage
    const [search, setSearch] = useState(false); // Search activation flag
    const [searchElement, setSearchElement] = useState(''); // Search query string
    const [simpleSearch, setSimpleSearch] = useState(false); // Flag to indicate if simple search mode is active
    const [criteria, setCriteria] = useState(); // State to store search criteria
    let dispatch = useDispatch(); // Initialize the Redux dispatch function

    // Clears search filters when the component mounts and unmounts
    useEffect(() => {
        return () => {
            dispatch(clearSearchFilters()); // Dispatch action to clear search filters
        };
    }, []); // Runs once on mount and unmount

    // Clears search filters and resets checkbox selection whenever the view changes
    useEffect(() => {
        dispatch(clearSearchFilters()); // Clear search filters
        resetAllCheckboxes(); // Reset all checkboxes to unchecked
        setSelectedList([]); // Clear selected contracts
        setIsAllChecked(false); // Reset the "select all" checkbox
    }, [view]); // Runs whenever the view changes

    // Function to reset all checkboxes to unchecked
    const resetAllCheckboxes = () => {
        const checkboxes = document.querySelectorAll('.checkbox');
        checkboxes.forEach((checkbox) => {
            checkbox.checked = false; // Uncheck the checkbox
        });
    };

    // Return all the relevant state and functions to be used by the component
    return {
        t,
        contractorId,
        supplierId,
        searchElement,
        setSearchElement,
        search,
        setSearch,
        setSimpleSearch,
        selectedList,
        setSelectedList,
        finalArray,
        setCriteria,
        isAllChecked,
        setIsAllChecked,
    };
};

// Exporting the CafeteriasApp component for use in other parts of the application
export default CafeteriasApp;
